<template>
    <div>
        <h2 class="text-center thank-you-heading">Verify OTP</h2>
        <p
            class="text-center paragraph"
            style="padding: 0px icon-customer-profil30px"
        >
            <template v-if="hideMobile">
                Please verify the OTP sent to your e-mail address
            </template>
            <template v-else>
                Please verify the OTP sent to your mobile number and e-mail
                address
            </template>
        </p>
        <b-form-group id="input-group-1" label="otp-code" label-for="otpcode">
            <b-form-input
                id="otpcode"
                v-model="otpCode"
                v-validate="{ required: true, max: 6, regex: /^([0-9]*)$/ }"
                type="text"
                required
                name="OTP code"
                autocomplete="no"
                placeholder="Enter OTP code"
            ></b-form-input>
            <span v-if="isError" class="text-center color-red">{{
                isError
            }}</span>
        </b-form-group>
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        :btn-label="
                            countDown > 0 ? 'Submit OTP' : 'Resend Code'
                        "
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                        @click="init()"
                    >
                    </base-button>
                </div>
            </div>
        </div>
        <p
            v-if="countDown > 0"
            class="text-center paragraph fs-13 my-3"
            style="padding: 0px icon-customer-profil30px"
        >
            Resend Code in {{ countDown }} seconds
        </p>
        <!-- <p
        class="text-center paragraph fs-13 my-3"
        style="padding: 0px icon-customer-profil30px"
    >
        I agree to <a href="www.google.com">Terms and Policies</a>
    </p> -->
        <!--    <b-modal-->
        <!--      ref="modalRecaptcha"-->
        <!--      size="sm"-->
        <!--      title=""-->
        <!--      hide-footer-->
        <!--      :click-to-close="false"-->
        <!--      :no-close-on-backdrop="true"-->
        <!--      :no-close-on-esc="true"-->
        <!--      :hide-header-close="true"-->
        <!--    >-->
        <!--      <div class="col-sm-10">-->
        <!--        <recaptcha @onVerify="onVerify"> </recaptcha>-->
        <!--      </div>-->
        <!--    </b-modal>-->
    </div>
</template>
<script>
import request from '@/utils/request'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    components: {
        PopupButton,
    },

    props: {
        data: { type: Object },
        hideMobile: { type: Boolean, default: false },
        isLoginModal: { type: Boolean, default: false },
    },

    data() {
        return {
            otpCode: '',
            resendDisable: true,
            countDown: 120,
            responseData: '',
            isError: '',
            recaptchaResponse: '',
        }
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    },
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */

    mounted() {
        this.countDownTimer()
        // console.log('PropsData: ' + JSON.stringify(this.data))
    },
    methods: {
        async onVerify(response) {
            if (response) {
                this.recaptchaResponse = response
                this.$refs.modalRecaptcha.hide()
                this.submitOTPOld()
            }
        },

        async submitOTP() {
            this.$store.commit('setLoading', true)
            const result = await this.$validator.validateAll()

            if (result) {
                const formData = {
                    otp: this.otpCode,
                }
                var mergedData = {
                    ...this.data,
                    ...formData,
                }
                console.log('margeData', mergedData)
                let encryptedForm = this.$encrypt(mergedData)
                console.log('marge data', mergedData)
                let resp = await axios
                    .post(`${process.env.VUE_APP_API_URL}auth/login`, {
                        data: encryptedForm,
                    })
                    .then((response) => {
                        return response
                    })
                    .catch((error) => {
                        const message = error.response
                            ? error.response.data.message
                            : 'Your IP has been blocked, please contact Admin'
                        this.isError = message
                        if (error.response) {
                            return { error: error.response.data.message }
                        } else if (error.request) {
                            // return {error :'No response received from server'}
                            return {
                                error: 'Your IP has been blocked, please contact Admin',
                            }
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            return { error: error.message }
                        }
                    })

                if (resp) {
                    this.isLogin = true
                    this.$emit('verificationStatus', resp, this.otpCode)
                } else {
                }
            } else {
                // this.$store.commit('setError', this.errors.all()[0])
            }

            this.$store.commit('setLoading', false)
        },
        async submitOTPOld() {
            this.$store.commit('setLoading', true)

            const result = await this.$validator.validateAll()
            if (!result) {
                this.isError = this.errors.all()[0]
                this.$store.commit('setLoading', false)
                return
            }

            try {
                const formData = this.$encrypt({
                    otpCode: this.otpCode,
                    token: this.data.data.token,
                    mobileNo: this.data.data.phoneNumber,
                    cToken: this.recaptchaResponse,
                })

                let { data } = await request({
                    url: `/configurations/verify-otp`,
                    method: 'post',
                    data: { data: formData },
                })
                console.log('data', data)
                if (data) {
                    this.$emit(
                        'verificationStatus',
                        { ...data.data, verificationStatus: data.data.status },
                        this.otpCode
                    )
                    if (!data.data.status) {
                        this.isError = data.data.message
                    }
                }
            } catch (e) {
                console.log('error', e)
                let message =
                    typeof e == 'string'
                        ? e
                        : error.response
                        ? error.response.data.message
                        : 'Something went wrong'
                this.isError = message
            } finally {
                this.$store.commit('setLoading', false)
            }
        },

        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.isError =
                    'Your OTP code is expired, please click resend OTP'
                this.resendDisable = false
            }
        },
        submitResend() {
            this.$emit('reSendOTP', '')
            this.initCountDown()
        },
        initCountDown() {
            this.countDownTimer()
            this.isError = null
        },
        async init() {
            console.log('init')
            if (this.countDown > 0) {
                const result = await this.$validator.validateAll()
                if (result) {
                    if (
                        this.$route.name === 'public-registration-preview-ssa'
                    ) {
                        this.$emit('OTPAfterCaptcha')
                    } else {
                        if (this.isLoginModal) {
                            this.submitOTP()
                        } else {
                            this.submitOTPOld()
                        }
                    }
                }
            } else {
                this.submitResend()
            }
        },
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}

.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
</style>
